// extracted by mini-css-extract-plugin
export default {"description":"a41eurHG","mobile":"mobile"};